import React from "react";
import './CloseButton.css'

const CloseButton = ({ onClick }) => {
    return (
        <div className="close-button" onClick={onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 38" fill="none">
                <rect width="41" height="38" rx="8" fill="#B1DDFF"/>
                <path d="M29 13.6114L27.3886 12L21 18.3886L14.6114 12L13 13.6114L19.3886 20L13 26.3886L14.6114 28L21 21.6114L27.3886 28L29 26.3886L22.6114 20L29 13.6114Z" fill="#454545"/>
            </svg>
        </div>
    );
}

export default CloseButton;